// src/components/auth/LogoutButton.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useWebSocket } from '../../context/WebSocketContext';
import { useChatWindow } from '../../App';
import Button from '../ui/Button';

const LogoutButton = ({ className = '' }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { disconnectWebSocket, setOpenChats } = useWebSocket();
  const { closeChat } = useChatWindow();

  const handleLogout = () => {
    disconnectWebSocket();
    closeChat();
    setOpenChats([]);
    logout();
    navigate('/');
  };

  return (
    <Button
      onClick={handleLogout}
      variant="primary"
      size="sm"
      className={`logout-btn ${className}`}
    >
      Log out
    </Button>
  );
};

export default LogoutButton;